import "./index.css"
import Header from "../header"
import TaskBar from "../taskbar"
import CopyRight from "../copyright"


const About = () => {


    return (
        <>
         
        <Header />
        <h2>About</h2>
        <div className="container-head ">
            <p>At Dream Destination Abroad, we understand that studying abroad is more than just an academic decision—it's a life-changing journey. Our experienced team is dedicated to helping students navigate the complex process of overseas education with ease and confidence. We offer end-to-end services including career counseling, course and university selection, application assistance, visa processing, pre-departure briefings, and more. Whether you’re aiming for top universities in the USA, UK, Canada, Australia, or other leading destinations, we ensure a smooth and successful transition from your home country to your dream destination. Our commitment to integrity, transparency, and student success has made us a trusted name among aspiring students and parents across Telangana and Andhra Pradesh.</p>
            <p>With over 10 years of experience in overseas education consulting, Dream Destination Abroad has proudly guided countless students in achieving their academic goals across the globe. Based in the Telugu states of Telangana and Andhra Pradesh, we specialize in providing personalized support and expert advice for studying in all major countries. From university selection to visa assistance, we are your trusted partner at every step of your international education journey.</p>

        </div>
        <hr />
        <h2>Why Choose Dream Destination?</h2>
        <ul>
            <li>13+ Years of Expertise in USA Admissions</li>
            <li>100% Visa Success Rate </li>
            <li>Profile-Based University Shortlisting </li>
            <li>Scholarship and Financial Aid Guidance</li>
            <li>Visa Interview Preparation </li>
            <li>Pre-Departure Briefing and Post-Arrival Support</li>
            <li>Transparent, Ethical Counseling </li>
        </ul>
        <p>We don’t just guide you to a university — we open the door to your future success! </p>
        <TaskBar />
        <CopyRight />
        </>
    )

}

export default About